export default __webpack_public_path__ + "static/image-30-04edb54dda91fb2742c8d7dbb2b15b62.jpg";